declare global {
  interface Window {
    _env_: InjectedVariables | undefined;
  }
}

/**
 * Get injected variables with fallback strategy for browser compatibility
 * Handles cases where process.env polyfill might fail (pounjs)
 */
function getInjectedVariables<T extends InjectedVariables>(): T {
  // Fallback
  let env = {} as T;

  if (typeof process !== 'undefined') {
    env = process.env as unknown as T;
  }

  if (typeof window !== 'undefined') {
    env = window._env_ as T;
    window._env_ = undefined;
  }

  return env;
}

export type InjectedVariables = {
  AG_GRID_LICENSE?: string | null;
  MAPBOX_ACCESS_TOKEN: string;
  ENVIRONMENT?: string;
  SENTRY_DSN: string | null;
};

export const {
  MAPBOX_ACCESS_TOKEN = process.env.MAPBOX_ACCESS_TOKEN,
  AG_GRID_LICENSE = null,
  ENVIRONMENT = process.env.ENVIRONMENT,
  SENTRY_DSN = null,
} = getInjectedVariables<InjectedVariables>();

export const NODE_ENV = process.env.NODE_ENV ?? 'production';
export const TEST = (process.env.TEST ?? '0') === '1';

export type CellWidthKeys = 'lg' | 'md' | 'sm' | 'xl' | 'xxl';

export const TABLE_WIDTHS_MAP: Record<CellWidthKeys, number> = {
  sm: 5,
  md: 6,
  lg: 8,
  xl: 10,
  xxl: 22,
};

export const MAX_RADIUS_FOR_CLUSTERS = 20;
export const MAX_THICKNESS_FOR_FLOWS = 0.8;
export const MIN_RADIUS_FOR_CLUSTERS = 8;
export const MIN_THICKNESS_FOR_FLOWS = 0.15;

export const PICKUP_COLOR: [number, number, number] = [147, 51, 234];
export const SALE_COLOR: [number, number, number] = [22, 163, 74];
export const TRANSFERT_COLOR: [number, number, number] = [251, 191, 36];

export const MAP_WINDOW_OFFSET = 200;

// Set to true to enable debug mode for Deck.gl layers, which can help with debugging rendering issues
export const ENABLE_DECK_GL_DEBUG = false;
